<ng-container [ngSwitch]="provider">
    <lib-gmap-movisat *ngSwitchCase="'Google'" [cartoType]="cartoType" [lang]="lang" [texts]="texts"
        [searchBounds]="searchBounds" [searchCountry]="searchCountry" [noSearch]="noSearch"
        (mapReady)="onMapReady($event)" (mapClick)="onMapClick($event)" (mapMouseMove)="onMapMouseMove($event)"
        (boundsChange)="onBoundsChange($event)" (zoomChange)="onZoomChange($event)"
        (markerClick)="onMarkerClick($event)" (markerClickGeoJson)="onMarkerClickGeoJson($event)"
        (markerDragEnd)="onMarkerDragEnd($event)" (markerMove)="onMarkerMove($event)"
        (polylineClick)="onPolylineClick($event)" (polygonClick)="onPolygonClick($event)"
        (polygonDragEnd)="onPolygonDragEnd($event)" (circleClick)="onCircleClick($event)"
        (circleDragEnd)="onCircleDragEnd($event)" (circleRadiusChanged)="onCircleRadiusChanged($event)"
        (mapSearch)="onMapSearch($event)">
    </lib-gmap-movisat>
    <lib-hmap-movisat *ngSwitchCase="'Here'" [cartoType]="cartoType" [lang]="lang" [texts]="texts"
        [searchBounds]="searchBounds" [searchCountry]="searchCountry" [noSearch]="noSearch"
        (mapReady)="onMapReady($event)" (mapClick)="onMapClick($event)" (mapMouseMove)="onMapMouseMove($event)"
        (boundsChange)="onBoundsChange($event)" (zoomChange)="onZoomChange($event)"
        (markerClick)="onMarkerClick($event)" (markerClickGeoJson)="onMarkerClickGeoJson($event)"
        (markerDragEnd)="onMarkerDragEnd($event)" (markerMove)="onMarkerMove($event)"
        (polylineClick)="onPolylineClick($event)" (polygonClick)="onPolygonClick($event)"
        (polygonDragEnd)="onPolygonDragEnd($event)" (circleClick)="onCircleClick($event)"
        (circleDragEnd)="onCircleDragEnd($event)" (circleRadiusChanged)="onCircleRadiusChanged($event)"
        (mapSearch)="onMapSearch($event)">
    </lib-hmap-movisat>
    <div *ngSwitchDefault>
        <b>Proveedor de cartografía no soportado!</b>
    </div>
</ng-container>